import { render, staticRenderFns } from "./AgendaAluno.vue?vue&type=template&id=cb231a86&"
import script from "./AgendaAluno.vue?vue&type=script&lang=js&"
export * from "./AgendaAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports